import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { MenuAction } from '@shared/interfaces/header/menu-action';
import { TranslatePipe } from '@ngx-translate/core';
import { AlertCircle, LucideAngularModule } from 'lucide-angular';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-dropdown',
  imports: [
    TranslatePipe,
    LucideAngularModule,
    NgClass
  ],
  templateUrl: './dropdown.component.html',
  styleUrl: './dropdown.component.css'
})
export class DropdownComponent {
  /** Inputs **/
  @Input() public collection: MenuAction[] = [];
  @Input() public value?: string | string[];
  @Input() public selectable: 'single' | 'multiple' = 'single';
  @Input() public directContent: boolean = false;
  @Input() public right: boolean = true;

  @Output() public valueChange: EventEmitter<string | string[]> = new EventEmitter<string | string[]>();

  /** Click Outside **/
  @HostListener('document:click', ['$event'])
  public clickOutside(event: Event): void {
    if (event instanceof MouseEvent || event instanceof TouchEvent || event instanceof PointerEvent || event instanceof KeyboardEvent) {
      if (!this.element.nativeElement.contains(event.target as Node)) {
        this.close()
      }
    }
  }

  /** Escape Key **/
  @HostListener('document:keydown', ['$event'])
  public onKeyDown(event: Event): void {
    if (event instanceof KeyboardEvent) {
      if (event.key === 'Escape') {
        this.close();
      }
    }
  }

  /** Close on window out of focus **/
  @HostListener('window:blur', ['$event'])
  public onBlur(event: FocusEvent): void {
    this.close();
  }

  /** Icons **/
  protected readonly AlertCircle = AlertCircle;

  public dropDownOpen: boolean = false;

  constructor(
    private readonly element: ElementRef,
  ) {

  }

  public toggle(): void {
    this.dropDownOpen = !this.dropDownOpen;
  }

  public open(): void {
    this.dropDownOpen = true;
  }

  public close(): void {
    this.dropDownOpen = false;
  }

  public selectItem(item: MenuAction): void {
    if (this.selectable === 'multiple') {
      if (!(Array.isArray(this.value))) {
        this.value = [];
      }
      if (this.value.includes(item.id)) {
        this.value = this.value.filter(v => v !== item.id)
      } else {
        this.value.push(item.id);
      }
    } else if (this.selectable === 'single') {
      this.value = item.id;
    }

    this.valueChange.emit(this.value);
  }
}
